import React from 'react';

import {MatchWidgetProps} from "../models/match-widget.props";
import {MatchWidgetController} from "../match-widget.controller";
import {MatchWidgetScheduledGameMobileComponent} from "./match-widget.scheduled-game-mobile-component";
import {MatchWidgetScheduledGameDesktopComponent} from "./match-widget.scheduled-game-desktop-component";
import {MatchTabStartedGameMobileComponent} from "./match-widget.started-game-mobile-component";
import {MatchWidgetStartedGameDesktopComponent} from "./match-widget.started-game-desktop-component";
import {MatchWidgetEndedGameMobileComponent} from "./match-widget.ended-game-mobile-component";
import {MatchWidgetEndedGameDesktopComponent} from "./match-widget.ended-game-desktop-component";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {GAME_STATUSES} from "../../../core/app/consts";
import {Loader, LoaderProps} from "../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import {MatchWidgetPlaceholder} from "./placeholders/match-widget.placeholder";
import styles from "../styles/match-widget.module.scss";
import classNames from "classnames";

export class MatchWidgetComponentProps extends MatchWidgetProps {
}

export const MatchWidgetComponent = ({controller, location, onSeeAllClick}: MatchWidgetComponentProps) => {
  const {state} = controller;
  const {device} = state;

  const ScheduledGameComponent = !device.isLargeView ? MatchWidgetScheduledGameMobileComponent : MatchWidgetScheduledGameDesktopComponent;
  const StartedGameComponent = !device.isLargeView ? MatchTabStartedGameMobileComponent : MatchWidgetStartedGameDesktopComponent;
  const EndedGameComponent = !device.isLargeView ? MatchWidgetEndedGameMobileComponent : MatchWidgetEndedGameDesktopComponent;

  const componentsByStatus = {
    [GAME_STATUSES.scheduled]: ScheduledGameComponent,
    [GAME_STATUSES.started]: StartedGameComponent,
    [GAME_STATUSES.ended]: EndedGameComponent,
  }

  const Component = componentsByStatus[state.statusGroup] || (() => null);


  const loaderProps: LoaderProps = {
    when: state.fetchingState === FETCHING_STATES.fetching || state.componentState === COMPONENT_STATES.loading,
    Component: () => <MatchWidgetPlaceholder/>
  }
  return (<Loader {...loaderProps}>
    <div className={classNames({[styles.small_view]: device.isSmallView})}>
      <Component controller={controller} location={location} onSeeAllClick={onSeeAllClick}/>
    </div>
  </Loader>);
}

const settings: ComposeSettings = {
  component: MatchWidgetComponent,
  propsType: MatchWidgetComponentProps,
  controllerType: MatchWidgetController,
  shouldTriggerOnRenderComplete: true,

  createModule: true,
  observe: true,
}

export default Compose(settings);
